package gr.tech.GRAttestation.util

import kotlinx.browser.document

// Created because I needed a way to open a bootstrap modal Programmatically, away from a button.
fun showBootstrapModal(modalId: String) {
    val modalElement = document.getElementById(modalId)
    if (modalElement != null) {
        js("new bootstrap.Modal(modalElement).show()")
    }
}

// Created because I needed a way to close a bootstrap modal Programmatically
fun closeModal(modalId: String) {
    val element = document.getElementById(modalId)
    if (element != null) {
        val modal = js("bootstrap.Modal.getInstance")(element)
            ?: js("new bootstrap.Modal")(element)
        modal.hide()
    }
}